import React from 'react'
import Header from '../compontents/Header'
import Menu from '../compontents/Menu'
import Footer from '../compontents/Footer'

const MenuPage = () => {
  return (
    <React.Fragment>
      <Header />
      <Menu />
      <Footer />
    </React.Fragment>
  )
}

export default MenuPage